var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"board"},[(_vm.$slots.title)?_c('h1',{staticClass:"board__title"},[_vm._t("title")],2):_vm._e(),(_vm.$slots.subtitle)?_c('h2',{staticClass:"board__subtitle"},[_vm._t("subtitle")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }